export default "__VITE_ASSET__D$N7gzCv__"